
export const truncateEmail = (email: string, maxLength: number = 21): string => {
  if (!email) return '';
  
  // Split email into local part and domain
  const atIndex = email.indexOf('@');
  if (atIndex === -1) return email;
  
  const localPart = email.slice(0, atIndex);
  const domain = email.slice(atIndex);
  
  // If email is already shorter than maxLength, return it as is
  if (email.length <= maxLength) {
    return email;
  }
  
  // For long emails, show first char + ... + last char of local part
  // Example: weerrtjfgldfgjhktztrz@gmail.com becomes w...z@gmail.com
  const firstChar = localPart.charAt(0);
  const lastChar = localPart.charAt(localPart.length - 1);
  
  return `${firstChar}...${lastChar}${domain}`;
};
